import { createContext, useContext, useState, ReactNode } from 'react'

interface ActiveActivity {
  name: string
  exitActivity: () => void
  showCloseButton?: boolean
}

interface ActivityContextType {
  activeActivity: ActiveActivity | null
  setActiveActivity: (activity: ActiveActivity | null) => void
}

const ActivityContext = createContext<ActivityContextType | undefined>(undefined)

export const ActivityProvider = ({ children }: { children: ReactNode }) => {
  const [activeActivity, setActiveActivity] = useState<ActiveActivity | null>(null)

  return <ActivityContext.Provider value={{ activeActivity, setActiveActivity }}>{children}</ActivityContext.Provider>
}

export const useActivity = (): ActivityContextType => {
  const context = useContext(ActivityContext)
  if (!context) {
    throw new Error('useActivity debe usarse dentro de un ActivityProvider')
  }
  return context
}
